/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const ResolvedHeaderWrapper = styled.div`
  align-items: center;
  display: flex;
`;

export const CollapsedHeaderWrapper = styled(ResolvedHeaderWrapper)`
  gap: 8px;
`;

export const CollapseExpandButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  flex: none;
  position: absolute;
  top: 5px;
  right: 8px;
  z-index: 1;
`;

export const ConversationWrapper = styled.div`
  position: relative;
`;

// Apply 32px margin between comments and the editor
export const CommentWrapper = styled.div`
  & > * + * {
    margin-top: ${token('space.400', '32px')};
  }
`;

export const DividingLine = styled.hr`
  background-color: ${token('color.border', colors.N30)};
  height: 1px;
  border: none;
`;

export const NameWrapper = styled.strong`
  margin-left: 8px;
  margin-right: 4px;
`;
